const formatToReal = (v) => {
    return parseFloat(v).toFixed(2).toString().replace('.', ',');
};

const formatToGramatura = (v) => {
    const val = parseFloat(v).toFixed(3).toString();

    return Number(val.replace(/\./, ''));
};

const formatToMilhar = (v) => {
    return Number(v).toFixed(3).toString().replace('.', ',');
};

export { formatToReal, formatToGramatura, formatToMilhar };
